import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Button from "components/Buttons";
import Row from "components/Row";
import Toast from "components/Toast";
import Input from "components/gads/Input";
import formatValue from "modules/utils/formatValue";
import googleActions from "modules/google/actions";
import googleSelectors from "modules/google/selectors";
import dateFormatter from "modules/utils/DateFormatter";

const ValidatedInput = ({ conversionName, validationFailed, value, onChange, onBlur }) => {
  return (
    <InputInTable
      className={validationFailed ? "boxError" : ""}
      type="text"
      full
      placeHolder="0.00"
      name={`${conversionName.toLowerCase()}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={(e) => onBlur(e.target.value)}
      margin="10px 0px !important"
    />
  );
};

const OfflineConversionSheets = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const rmpToken = sessionStorage.getItem("rmp_token");
  const googleSheetsOfflineConversionsValue = useSelector((state) =>
    googleSelectors.getGoogleSheetsOfflineConversionsValueResult(state),
  );
  const googleSheetsOfflineConversionsLastSent = useSelector((state) =>
    googleSelectors.getGoogleSheetsOfflineConversionsLastSentResult(state),
  );
  const [showFailedToast, setShowFailedToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [lastSentConversion1, setLastSentConversion1] = useState(false);
  const [lastSentConversion2, setLastSentConversion2] = useState(false);
  const [lastSentConversion3, setLastSentConversion3] = useState(false);
  const [lastSentConversion4, setLastSentConversion4] = useState(false);
  const [lastSentConversion5, setLastSentConversion5] = useState(false);
  const [lastSentConversion6, setLastSentConversion6] = useState(false);
  const [lastSentConversion7, setLastSentConversion7] = useState(false);
  const [lastSentConversion8, setLastSentConversion8] = useState(false);
  const [lastSentConversion9, setLastSentConversion9] = useState(false);
  const [lastSentConversion10, setLastSentConversion10] = useState(false);
  const [inputConversion1, setInputConversion1] = useState("0.00");
  const [inputConversion2, setInputConversion2] = useState("0.00");
  const [inputConversion3, setInputConversion3] = useState("0.00");
  const [inputConversion4, setInputConversion4] = useState("0.00");
  const [inputConversion5, setInputConversion5] = useState("0.00");
  const [inputConversion6, setInputConversion6] = useState("0.00");
  const [inputConversion7, setInputConversion7] = useState("0.00");
  const [inputConversion8, setInputConversion8] = useState("0.00");
  const [inputConversion9, setInputConversion9] = useState("0.00");
  const [inputConversion10, setInputConversion10] = useState("0.00");
  const [validateFailedConversion1, setValidateFailedConversion1] = useState(false);
  const [validateFailedConversion2, setValidateFailedConversion2] = useState(false);
  const [validateFailedConversion3, setValidateFailedConversion3] = useState(false);
  const [validateFailedConversion4, setValidateFailedConversion4] = useState(false);
  const [validateFailedConversion5, setValidateFailedConversion5] = useState(false);
  const [validateFailedConversion6, setValidateFailedConversion6] = useState(false);
  const [validateFailedConversion7, setValidateFailedConversion7] = useState(false);
  const [validateFailedConversion8, setValidateFailedConversion8] = useState(false);
  const [validateFailedConversion9, setValidateFailedConversion9] = useState(false);
  const [validateFailedConversion10, setValidateFailedConversion10] = useState(false);
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);

  const conversionMappings = {
    "GSheets-Conversion1": {
      leadStep: "Conversion 1",
      conversionName: "GSheets-Conversion1",
      setLastSent: setLastSentConversion1,
      lastSent: lastSentConversion1,
      inputConversionName: "inputConversion1",
      setInput: setInputConversion1,
      input: inputConversion1,
      setValidateFailed: setValidateFailedConversion1,
      validateFailed: validateFailedConversion1,
    },
    "GSheets-Conversion2": {
      leadStep: "Conversion 2",
      conversionName: "GSheets-Conversion2",
      setLastSent: setLastSentConversion2,
      lastSent: lastSentConversion2,
      inputConversionName: "inputConversion2",
      setInput: setInputConversion2,
      input: inputConversion2,
      setValidateFailed: setValidateFailedConversion2,
      validateFailed: validateFailedConversion2,
    },
    "GSheets-Conversion3": {
      leadStep: "Conversion 3",
      conversionName: "GSheets-Conversion3",
      setLastSent: setLastSentConversion3,
      lastSent: lastSentConversion3,
      inputConversionName: "inputConversion3",
      setInput: setInputConversion3,
      input: inputConversion3,
      setValidateFailed: setValidateFailedConversion3,
      validateFailed: validateFailedConversion3,
    },
    "GSheets-Conversion4": {
      leadStep: "Conversion 4",
      conversionName: "GSheets-Conversion4",
      setLastSent: setLastSentConversion4,
      lastSent: lastSentConversion4,
      inputConversionName: "inputConversion4",
      setInput: setInputConversion4,
      input: inputConversion4,
      setValidateFailed: setValidateFailedConversion4,
      validateFailed: validateFailedConversion4,
    },
    "GSheets-Conversion5": {
      leadStep: "Conversion 5",
      conversionName: "GSheets-Conversion5",
      setLastSent: setLastSentConversion5,
      lastSent: lastSentConversion5,
      inputConversionName: "inputConversion5",
      setInput: setInputConversion5,
      input: inputConversion5,
      setValidateFailed: setValidateFailedConversion5,
      validateFailed: validateFailedConversion5,
    },
    "GSheets-Conversion6": {
      leadStep: "Conversion 6",
      conversionName: "GSheets-Conversion6",
      setLastSent: setLastSentConversion6,
      lastSent: lastSentConversion6,
      inputConversionName: "inputConversion6",
      setInput: setInputConversion6,
      input: inputConversion6,
      setValidateFailed: setValidateFailedConversion6,
      validateFailed: validateFailedConversion6,
    },
    "GSheets-Conversion7": {
      leadStep: "Conversion 7",
      conversionName: "GSheets-Conversion7",
      setLastSent: setLastSentConversion7,
      lastSent: lastSentConversion7,
      inputConversionName: "inputConversion7",
      setInput: setInputConversion7,
      input: inputConversion7,
      setValidateFailed: setValidateFailedConversion7,
      validateFailed: validateFailedConversion7,
    },
    "GSheets-Conversion8": {
      leadStep: "Conversion 8",
      conversionName: "GSheets-Conversion8",
      setLastSent: setLastSentConversion8,
      lastSent: lastSentConversion8,
      inputConversionName: "inputConversion8",
      setInput: setInputConversion8,
      input: inputConversion8,
      setValidateFailed: setValidateFailedConversion8,
      validateFailed: validateFailedConversion8,
    },
    "GSheets-Conversion9": {
      leadStep: "Conversion 9",
      conversionName: "GSheets-Conversion9",
      setLastSent: setLastSentConversion9,
      lastSent: lastSentConversion9,
      inputConversionName: "inputConversion9",
      setInput: setInputConversion9,
      input: inputConversion9,
      setValidateFailed: setValidateFailedConversion9,
      validateFailed: validateFailedConversion9,
    },
    "GSheets-Conversion10": {
      leadStep: "Conversion 10",
      conversionName: "GSheets-Conversion10",
      setLastSent: setLastSentConversion10,
      lastSent: lastSentConversion10,
      inputConversionName: "inputConversion10",
      setInput: setInputConversion10,
      input: inputConversion10,
      setValidateFailed: setValidateFailedConversion10,
      validateFailed: validateFailedConversion10,
    },
  };

  useEffect(() => {
    if (
      googleSheetsOfflineConversionsValue.result == 0 &&
      googleSheetsOfflineConversionsValue.data &&
      googleSheetsOfflineConversionsValue.data.length > 0
    ) {
      googleSheetsOfflineConversionsValue.data.map((item, index) => {
        if (item.source == "g_sheets") {
          const conversionMapping = conversionMappings[item.conversion_name];
          if (conversionMapping) {
            let { setInput, setValidateFailed } = conversionMapping;
            if (item.conversion_value != null && item.conversion_value != undefined && item.conversion_value != "") {
              item.conversion_value = item.conversion_value.toString().replace(/,/g, "");
              item.conversion_value = parseFloat(item.conversion_value).toFixed(2);
              item.conversion_value = formatValue.formattedValueWithComma(item.conversion_value, 2);
              setInput(item.conversion_value);
            } else {
              setInput("0.00");
            }
            setValidateFailed(false);
          }
        }
      });
    }
  }, [googleSheetsOfflineConversionsValue]);

  useEffect(() => {
    if (
      googleSheetsOfflineConversionsLastSent.result == 0 &&
      googleSheetsOfflineConversionsLastSent.data &&
      googleSheetsOfflineConversionsLastSent.data.length > 0
    ) {
      googleSheetsOfflineConversionsLastSent.data.map((item) => {
        const conversionMapping = conversionMappings[item.conversion_name];
        if (conversionMapping) {
          let { setLastSent } = conversionMapping;
          if (item.last_sent_datetime) {
            setLastSent(dateFormatter.formatDatetimeFull(item.last_sent_datetime, sessionStorage.getItem("lang")));
          }
        }
      });
    }
  }, [googleSheetsOfflineConversionsLastSent]);

  const validateInputSubmit = (inputValue, setShowFailedToast, setValidationState) => {
    if (!inputValue) {
      setShowFailedToast(true);
      setValidationState(true);
      return false;
    }
    return true;
  };

  const gsheetsSubmit = async (e) => {
    setSubmitButtonLoading(true);
    e.preventDefault();
    const validateInputResults = Object.keys(conversionMappings).map((key, index) => {
      return validateInputSubmit(
        conversionMappings[key].input,
        setShowFailedToast,
        conversionMappings[key].setValidateFailed,
      );
    });

    if (validateInputResults.some((result) => !result)) {
      setSubmitButtonLoading(false);
      setShowFailedToast(true);
      return;
    } else {
      let data = [];
      Object.keys(conversionMappings).map((key, index) => {
        if (
          conversionMappings[key].input != undefined &&
          conversionMappings[key].input != "" &&
          conversionMappings[key].input != null
        ) {
          conversionMappings[key].input = formatValue.formattedValueWithoutComma(conversionMappings[key].input);
          conversionMappings[key].input = parseFloat(conversionMappings[key].input).toFixed(2);
        } else {
          conversionMappings[key].input = "0.00";
        }
        data.push({
          conversionStatus: "active",
          conversion_name: conversionMappings[key].conversionName,
          conversion_value: conversionMappings[key].input,
        });
      });

      await dispatch(
        googleActions.setGoogleSheetsOfflineConversionsValue({
          token: rmpToken,
          pipelineSteps: data,
        }),
      );
      setSubmitButtonLoading(false);
      setShowSuccessToast(true);
      setShowFailedToast(false);
    }
  };

  const validateInput = (input, conversionName) => {
    const regex = /^[0-9]*(\.[0-9]*)?$/;
    const isValid = regex.test(input);
    const conversionMapping = conversionMappings[conversionName];
    if (conversionMapping) {
      const { setValidateFailed } = conversionMapping;
      if (!isValid) {
        setValidateFailed(true);
      } else {
        setValidateFailed(false);
      }
    }
    return isValid;
  };

  const handleInputChange = (value, conversionName) => {
    const conversionMapping = conversionMappings[conversionName];
    if (conversionMapping) {
      const { setInput } = conversionMapping;
      if (value != "" && value != null && value != undefined) {
        let numericValue = value.replace(/[^\d.]/g, "");
        validateInput(value, conversionName);
        setInput(numericValue);
      } else {
        setInput("");
      }
    }
  };

  const handleFormatInputChange = (value, conversionName) => {
    const conversionMapping = conversionMappings[conversionName];
    if (conversionMapping) {
      const { setInput } = conversionMapping;
      if (value != "" && value != null && value != undefined) {
        let numericValue = value.replace(/[^\d.]/g, "");
        let formattedValueWithComma = formatValue.formattedValueWithComma(numericValue, 2);
        setInput(formattedValueWithComma);
      } else {
        setInput("");
      }
    }
  };

  const successToastCallback = (value) => {
    if (showSuccessToast !== value) {
      setShowSuccessToast(value);
    }
  };

  const failedToastCallback = (value) => {
    setShowFailedToast(value);
  };

  const view = () => {
    return (
      <>
        <Description>{t("__ads_google_sheets_description")}</Description>
        <form>
          <Table>
            <thead>
              <tr>
                <th className="google-sheets-title" colSpan="1">
                  Google Sheets
                </th>
                <th className="google-ads-title" colSpan="2">
                  Google Ads
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="sub-title">{t("__lead_step")}</td>
                <td className="sub-title">{t("__ads_google_sheets_conversion_name")}</td>
                <td style={{ width: "100px" }} className="sub-title hideOnMobile">
                  {t("__ads_initial_value")}
                </td>
              </tr>
              {Object.keys(conversionMappings).map((key, index) => {
                return (
                  <tr key={index}>
                    <td className="text-left">{conversionMappings[key].leadStep}</td>
                    <td className="text-left">
                      <div>{conversionMappings[key].conversionName}</div>
                      <div className="hideOnDesktop">
                        <label className="secondary-text">{t("__ads_initial_value")}</label>
                        <ValidatedInput
                          conversionName={conversionMappings[key].inputConversionName}
                          validationFailed={conversionMappings[key].validateFailed}
                          value={conversionMappings[key].input}
                          onChange={(value) => handleInputChange(value, key)}
                          onBlur={(value) => handleFormatInputChange(value, key)}
                        />
                      </div>
                      <div className="secondary-text">
                        {t("__last_updated")}
                        {conversionMappings[key].lastSent
                          ? conversionMappings[key].lastSent
                          : t("__ads_conversion_no_data")}
                      </div>
                    </td>
                    <td className="text-right hideOnMobile">
                      <ValidatedInput
                        conversionName={conversionMappings[key].inputConversionName}
                        validationFailed={conversionMappings[key].validateFailed}
                        value={conversionMappings[key].input}
                        onChange={(value) => handleInputChange(value, key)}
                        onBlur={(value) => handleFormatInputChange(value, key)}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <BottomSticky>
            <RowAlignRight alignItems="stretch">
              <Button type="loading" onClick={(e) => gsheetsSubmit(e)} loading={submitButtonLoading}>
                {t("__ads_setup_save")}
              </Button>
            </RowAlignRight>
          </BottomSticky>
        </form>
        <Toast
          show={showSuccessToast}
          message={t("__ads_setup_save_success")}
          bgColor="#4CAF50"
          callback={successToastCallback}
        ></Toast>
        <Toast
          show={showFailedToast}
          message={t("__ads_crm_conversion_conversion_value_not_valid")}
          bgColor="#F44336"
          callback={failedToastCallback}
        ></Toast>
      </>
    );
  };
  return view();
};

export default OfflineConversionSheets;

const Description = styled.div`
  padding: 10px 0px;
  font-size: 14px;
  color: #999;
`;

const Table = styled.table`
  border-collapse: collapse;
  border: 1px solid #eee;
  width: 100%;
  font-size: 14px;

  th,
  td {
    border: 1px solid #eee;
    padding: 10px;
    width: 50%;
  }

  .sub-title {
    background-color: #f9f9f9;
    color: #555;
    /* font-size: 12px; */
    text-align: center;
    /* padding: 5px 10px; */
  }

  .google-sheets-title {
    color: #fff;
    background-color: #2196f3;
    width: 40%;
  }

  .google-ads-title {
    color: #fff;
    background-color: #4caf50;
  }

  .secondary-text {
    color: #aaa;
    font-size: 12px;
  }
  .hideOnDesktop {
    display: none;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    font-size: 13px;

    .hideOnMobile {
      display: none;
    }
    .hideOnDesktop {
      display: block;
    }
  }
`;

const BottomSticky = styled.div`
  position: sticky;
  bottom: -16px;
  padding: 10px;
  width: 100%;
  background: #fff;

  @media screen and (min-width: 320px) and (max-width: 480px) {
    overflow-y: hidden;
    left: 0;
    right: 0;
    margin: 0px -16px;
  }
`;

const RowAlignRight = styled(Row)`
  justify-content: flex-end;
`;

const InputInTable = styled(Input)`
  width: 100%;
  text-align: right;
  border: 1px solid #ddd; /* Set a default border */

  &:focus,
  &:active {
    outline: none;
    border: 1px solid #ddd !important; /* Increase specificity and use !important */
  }

  &.boxError {
    outline: none;
    border: 1px solid red; /* Set border color for boxError class */
  }

  &.boxError:focus,
  &.boxError:active {
    outline: none;
    border: 1px solid red !important; /* Increase specificity and use !important */
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    margin-top: 0px !important;
  }
`;
